import { useState } from "react";
import { Box, Button, Chip, TextField, Typography } from "@mui/material";
import { Add } from "@mui/icons-material";

interface ChipListEditorProps {
  label: string;
  values: string[];
  onChange: (v: string[]) => void;
}

export default function ChipListEditor({ label, values, onChange }: ChipListEditorProps) {
  const [input, setInput] = useState("");

  const handleAdd = () => {
    const trimmed = input.trim();
    if (trimmed && !values.includes(trimmed)) {
      onChange([...values, trimmed]);
    }
    setInput("");
  };

  return (
    <Box>
      <Typography variant="subtitle2" sx={{ mb: 0.5 }}>
        {label}
      </Typography>
      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5, mb: 1 }}>
        {values.map((v) => (
          <Chip
            key={v}
            label={v}
            size="small"
            onDelete={() => onChange(values.filter((x) => x !== v))}
          />
        ))}
      </Box>
      <Box sx={{ display: "flex", gap: 1 }}>
        <TextField
          size="small"
          value={input}
          onChange={(e) => setInput(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
              handleAdd();
            }
          }}
          placeholder={`Add ${label.toLowerCase()}...`}
          sx={{ flex: 1 }}
        />
        <Button size="small" variant="outlined" onClick={handleAdd} startIcon={<Add />}>
          Add
        </Button>
      </Box>
    </Box>
  );
}
